/* flow */

// NOTE: This file should be removed as customer support chats are no longer 
// supported. Customers are now sent to `https://support.rachio.com/`

import { Config } from './config'
import { get as getUser } from '../ducks/user/crud'
import { observeStore } from './redux'
import {
  userAuthTokenSelector,
  userIdSelector,
  currentUserSelector
} from '../ducks/user/selectors'

/**
 * @summary All help functionlity. Currently using Kustomer (previously zenDesk).
 * @see {@link https://docs.google.com/spreadsheets/d/1aSuV0a9gpww7Msx0uVB5RlyTy4dGVnSP-SDvYaSXIW4/edit#gid=735414754}
 * @module util/help
 */

/** Default help screen label */
export const defaultLabel: 'sdk-default' = 'sdk-default'

/**
 * Retrieve help object
 * @returns {object} - Help object
 */
// const get: ?Object = () => window.Kustomer

// /**
//  * Get current device name
//  * @param  {object} store - Redux store
//  * @return {[string]} - Device name or `null`
//  */
// const getCurrentDeviceName = store => {
//   let deviceName = null
//   const state = store.getState()
//   const currentRoute = state.routing.location.pathname
//   const match = matchPath(currentRoute, { path: '/devices/:locationId' })

//   if (match && match.params && match.params.locationId) {
//     const location = state.location[match.params.locationId]
//     if (location) {
//       const device = location.devices.find(deviceIsIrrigationController)
//       if (device) {
//         deviceName = device.name
//       }
//     }
//   }

//   return deviceName
// }

// /** Hide specific form fields, and set the value on others */
// const setAndHideFormFields = () => {
//   /** UA parser */
//   const parser = new UAParser()
//   /** UA data */
//   const deviceData = parser.getResult()
//   /** Field ID -> What it is */
//   const fieldsMap = Object.freeze({
//     '81128567': 'LABEL',
//     '81110287': 'OS',
//     '81110367': 'CURRENT_DEVICE',
//     '81110327': 'MODEL',
//     '81110307': 'APP_VERSION',
//     '360000061767': 'BROWSER',
//     '360000061787': 'BROWSER_VERSION',
//     '81173187': 'DEBUG_SESSION_URL'
//   })
//   /** Field -> data */
//   const fieldsData = Object.freeze({
//     APP_VERSION: VERSION + '-' + BUILD_NUMBER,
//     BROWSER_VERSION: deviceData.browser.version,
//     BROWSER: deviceData.browser.name,
//     CURRENT_DEVICE: getCurrentDeviceName(Store),
//     DEBUG_SESSION_URL: LogRocket.sessionURL,
//     LABEL: window.location.href,
//     MODEL: deviceData.device.model,
//     OS: deviceData.os.name
//   })
//   /** Fields to hide */
//   const fieldsToHide = Array.from(Object.keys(fieldsMap))
//   /** All field elements */
//   const fieldElms = Array.from(
//     document
//       .querySelector('#webWidget')
//       .contentDocument.querySelectorAll('.src-component-field-Field-container')
//   )
//   /** Selector to find any of the fields we're trying to hide */
//   const fieldSelectorStr = fieldsToHide.reduce(function(acc, id, idx) {
//     return acc + (idx > 0 ? ', ' : '') + 'input[name="' + id + '"]'
//   }, '')

//   // Loop through all the form elements, looking for
//   // form ids we're trying to hide
//   fieldElms.forEach(function(elm) {
//     const elmContainsFieldToHide = Array.from(
//       elm.querySelectorAll(fieldSelectorStr)
//     )

//     // If we found a form fields we're trying to hide, hide it, and if we
//     // have a value for it, set that
//     if (elmContainsFieldToHide.length > 0) {
//       const inputElm = elmContainsFieldToHide[0]
//       const formFieldId = inputElm.getAttribute('name')
//       const label = fieldsMap[formFieldId]

//       elm.style.display = 'none'

//       if (fieldsData[label]) {
//         inputElm.value = fieldsData[label]
//       }
//     }
//   })
// }

/* eslint-disable */
/**
 * Initialize Help Plugin
 */
export const init: () => void = () => {
  !(function(a, b, c, d) {
    ;(a.Kustomer = c),
      (c._q = []),
      (c._i = []),
      (c.init = function(a) {
        function b(a, b) {
          a[b] = function() {
            a._q.push([b].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }
        for (
          var d = 'init clear identify track start describe on'.split(' '),
            e = 0;
          e < d.length;
          e++
        )
          b(c, d[e])
        c._i.push(a)
      })
    var e = b.createElement('script')
    ;(e.type = 'text/javascript'),
      (e.async = !0),
      (e.src = 'https://cdn.kustomerapp.com/cw/sdk.v1.1.min.js')
    var f = b.getElementsByTagName('script')[0]
    f.parentNode.insertBefore(e, f)
  })(window, document, window.Kustomer || {})

  // Add your API key here
  window.Kustomer.init(Config.KUSTOMER_CHAT_KEY)
}
/* eslint-enable */

/**
 * Setup in-app help (meant to be run once @ statup)
 * @param  {Object} store - Redux store; note that this is not it's `state` but the entire store object
 */
export const setup = (store: Object) => {
  // Install
  init()

  // Set default label
  // setScreenLabels(defaultLabel)

  // Pull user for help
  const userAuthToken: ?string = userAuthTokenSelector(store.getState())
  const userId: ?string = userIdSelector(store.getState())
  const user: ?Object = currentUserSelector(store.getState())

  if (userId && userAuthToken && !user) {
    // Get user
    store.dispatch(getUser(userAuthToken, userId))
  }

  // When user changes, set user
  observeStore(store, currentUserSelector, (user?: Object) => {
    if (
      user &&
      !user.role.includes('ADMIN') &&
      !user.role.includes('AUDITOR')
    ) {
      const options = {
        new: true,
        icon: false
        // form: 'formId',
        // schedule: 'scheduleId'
      }

      // Start the chat client
      window.Kustomer.start(options)

      setUser({
        id: user.id,
        name: user.firstName + ' ' + user.lastName,
        email: user.emailAddress
      })
    }
  })
}

/** Open help */
export const open: () => void = () => {
  window.open('https://support.rachio.com/', '_blank')
  //window.Kustomer.open()
}

/** Hide default "Help" button */
export const hide: () => void = () => {
  window.Kustomer.stop()
}

type SetUser = ({ email: string }) => void

/**
 * @summary Set current user in help
 * @description {@link https://support.kustomer.com/chat-sdk-SJcSQ9ki4}
 * @param {string} id - User ID
 */
export const setUser: SetUser = ({ email = '' }) => {
  // Add a shared email to the customer record and suggest verification or merge
  window.Kustomer.describeCustomer({ email })

  // Add a custom attribute to the customer record (attribute must exist)
  // window.Kustomer.describeCustomer({ custom: { someAttributeStr: 'foo' } });
}

/**
 * Set help labels for current screen/section/error
 * @see {@link https://docs.google.com/spreadsheets/d/1aSuV0a9gpww7Msx0uVB5RlyTy4dGVnSP-SDvYaSXIW4/edit#gid=735414754}
 * @param {string} labels - Label(s) to apply to help
 * @returns {string} - Returning to stop build errors
 */
export const setScreenLabels = (...labels: string) => {
  return labels
  // const help: ?Object = get()
  // if (help) {
  //   help(() => {
  //     get().setHelpCenterSuggestions({ labels: [...labels] })
  //   })
  // } else {
  //   logger.warn('Trying to set labels in help before help is initialized')
  // }
}

/**
 * Set help labels to default
 * @see {@link https://docs.google.com/spreadsheets/d/1aSuV0a9gpww7Msx0uVB5RlyTy4dGVnSP-SDvYaSXIW4/edit#gid=735414754}
 */
export const unsetScreenLabels = () => {
  // const help: ?Object = get()
  // if (help) {
  //   setScreenLabels(defaultLabel)
  // } else {
  //   logger.warn('Trying to unset labels in help before help is initialized')
  // }
}
